<script>
export default {
  data() {
    return {
      title: "Storage",
      text: "Others Settings",
      text1: "Storage",
    };
  },
};
</script>
<template>
  <admin-header></admin-header>
  <admin-sidebar></admin-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Page Header -->
      <user-breadcrumb :title="title" :text="text" :text1="text1" />
      <!-- Page Header -->

      <!-- Social-Authentication Settings -->
      <div class="card setting-card">
        <div class="card-body">
          <settings-top></settings-top>
          <div class="row gx-3">
            <div class="col-xl-3 col-md-4">
              <others-sidebar></others-sidebar>
            </div>
            <div class="col-xl-9 col-md-8">
              <div class="card setting-content mb-0">
                <div class="card-header px-0 mx-3">
                  <h4>Storage</h4>
                </div>
                <div class="card-body pb-0">
                  <div class="row gx-3">
                    <div class="col-md-6 col-sm-12 d-flex">
                      <div class="card flex-fill mb-3">
                        <div class="card-body">
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                              <span class="avatar avatar-lg bg-light me-2"
                                ><img
                                  src="@/assets/admin/img/Settings/local-storage-icons.svg"
                                  alt="icons"
                                  class="w-auto h-auto"
                              /></span>
                              <h6 class="fs-14 fw-medium">Local Storage</h6>
                            </div>
                            <div class="d-flex align-items-center">
                              <a
                                href="#"
                                class="d-flex align-items-center"
                                data-bs-toggle="modal"
                                data-bs-target="#add_aws"
                                ><i class="ti ti-settings me-2"></i
                              ></a>
                              <div class="form-check form-switch">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-sm-12 d-flex">
                      <div class="card flex-fill mb-3">
                        <div class="card-body">
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="d-flex align-items-center">
                              <span class="avatar avatar-lg bg-light me-2"
                                ><img
                                  src="@/assets/admin/img/Settings/aws-icon.svg"
                                  alt="icons"
                                  class="w-auto h-auto"
                              /></span>
                              <h6 class="fs-14 fw-medium">AWS</h6>
                            </div>
                            <div class="d-flex align-items-center">
                              <a
                                href="#"
                                class="d-flex align-items-center"
                                data-bs-toggle="modal"
                                data-bs-target="#add_aws"
                                ><i class="ti ti-settings me-2"></i
                              ></a>
                              <div class="form-check form-switch">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Social-Authentication Settings -->
    </div>
  </div>
  <!-- /Page Wrapper -->
  <storage-settings-modal></storage-settings-modal>
</template>
